import containerFuild from '../html-snippets/container-fuild.js';
import buttonPrimary from '@/views/website/products/components/description/ui-modules/button-primary/raw-html.js';
import css from '../css-snippets/section-furnitureshop-banner-02.js';

const benefitIcon = 'https://cdn.skyfastimg.com/images/2026/09/09/image-6aa0bff1132bcad8dfe330f7.png?w=500';

const benefitItem = text => `
  <li class='furnitureshop-banner-02__item' data-attribute='furnitureshop-banner-02__item'>
    <img
      class='furnitureshop-banner-02__item-icon'
      data-attribute='furnitureshop-banner-02__item-icon'
      src='${benefitIcon}'
      alt=''
    />
    <span class='furnitureshop-banner-02__item-text' data-attribute='furnitureshop-banner-02__item-text'>
      ${text}
    </span>
  </li>
`;

const buttonHtml = buttonPrimary({
  text: 'BUY NOW',
  backgroundColor: '#FF8100',
  color: '#FFFFFF',
  radius: 4,
  iconPrefix: { show: false, src: '' },
  iconSuffix: {
    show: true,
    src: 'https://cdn.skyfastimg.com/images/2026/08/19/image-6a85790b9a1e4455d92f0d2b.avif?w=200',
  },
  subBtn: { show: false, text: '' },
});

const contentHtml = `
  <div class='furnitureshop-banner-02 container' data-attribute='furnitureshop-banner-02'>
    <header class='furnitureshop-banner-02__header' data-attribute='furnitureshop-banner-02__header'>
      <div class='furnitureshop-banner-02__title' data-attribute='furnitureshop-banner-02__title'>
        <h2>
          <span style="font-size: 40px"><strong>9H+ Crystal Layer,</strong></span><br />
          <span style="font-size: 40px"><strong>Against Scratches</strong></span>
        </h2>
      </div>
      <div class='furnitureshop-banner-02__heading'>
        <img
          class='furnitureshop-banner-02__decor'
          data-attribute='furnitureshop-banner-02__decor'
          src='https://cdn.skyfastimg.com/images/2026/08/20/image-6a86740aab3a65f2691e0790.png?w=500'
          alt=''
        />
        <div
          class='furnitureshop-banner-02__description'
          data-attribute='furnitureshop-banner-02__description'
        >
          <p>Shields against high-speed stone chips and<br />micro-damage from daily washing and contact.</p>
        </div>
      </div>
    </header>
    <div class='furnitureshop-banner-02__content' data-attribute='furnitureshop-banner-02__content'>
      <div class='furnitureshop-banner-02__logo-wrapper'>
        <img
          class='furnitureshop-banner-02__logo'
          data-attribute='furnitureshop-banner-02__logo'
          src='https://cdn.skyfastimg.com/images/2026/09/09/image-6aa0c0002e630363b499e7e6.avif?w=1000'
          alt='Made in Germany'
        />
      </div>
      <ul class='furnitureshop-banner-02__items' data-attribute='furnitureshop-banner-02__items'>
        ${benefitItem('Scratch Resistant')}
        ${benefitItem('Swirl Defense')}
        ${benefitItem('Impact Shield')}
      </ul>
      <div class='furnitureshop-banner-02__cta' data-attribute='furnitureshop-banner-02__cta'>
        ${buttonHtml}
      </div>
    </div>
  </div>
`;

export default containerFuild(contentHtml, css, {
  backgroundColor: '#05090D',
  textColor: '#FFFFFF',
  backgroundImage: 'https://cdn.skyfastimg.com/images/2026/09/09/image-6aa0c03d53803607badc3d96.webp?w=1000',
  useBackgroundMobile: true,
  backgroundImageMobile: 'https://cdn.skyfastimg.com/images/2026/09/09/image-6aa0c041244cb2d9d924a975.webp?w=1000',
  topPadding: false,
  bottomPadding: false,
});
